import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Sidebar} from 'primereact/sidebar'
import {useCallback, useEffect} from 'react'
import logo from '../../assets/icons/TaVIELogo.png'
import PageContentWrapper from '../layout/PageContentWrapper'
import {errorEvent, removeErrorModal} from './ErrorService'

const CoolDown = () => {
    useSignals()
    const visible = useSignal(false)

    const toggleModal = useCallback(() => {
        visible.value = prevState => !prevState
    }, [visible])

    useEffect(() => {
        errorEvent.on('ERROR-MODAL', () => toggleModal())
        const timer = setTimeout(() => {
            visible.value = false
            removeErrorModal()
        }, 10000)

        return () => {
            clearTimeout(timer)
            removeErrorModal()
        }
    }, [toggleModal])

    return (
        <Sidebar
            className="hide-sidebar-close p-sidebar-full "
            visible={visible.value}
            onHide={() => (visible.value = false)}
            fullScreen>
            <PageContentWrapper>
                <div className="flex align-items-center justify-content-center overflow-hidden">
                    <div className="flex flex-column align-items-center justify-content-center">
                        <img
                            src={logo}
                            alt="Logo"
                            className="mb-5 w-6rem flex-shrink-0"
                        />
                        <div
                            style={{
                                borderRadius: '56px',
                                padding: '0.3rem',
                                background:
                                    'linear-gradient(180deg, rgba(20,184,166, 0.4) 20%, rgba(20,184,166, 0) 80%)',
                            }}>
                            <div
                                className="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center"
                                style={{borderRadius: '53px'}}>
                                <div
                                    className="flex justify-content-center align-items-center bg-cyan-500 border-circle"
                                    style={{height: '3.2rem', width: '3.2rem'}}>
                                    <i className="pi pi-fw pi-exclamation-circle text-2xl text-white"></i>
                                </div>
                                <h1 className="text-primary text-6xl mb-2">
                                    TOO MANY REQUEST
                                </h1>
                                <div className="text-600 text-4xl mb-5">
                                    This site can't be reached.
                                </div>
                                <img
                                    src={require('../../assets/images/many requests.png')}
                                    alt="Error"
                                    className="mb-8"
                                    width="40%"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </PageContentWrapper>
        </Sidebar>
    )
}

export default CoolDown
